import { useEffect, useState } from "react";
import styles from "./Projects.module.css";
import ProjectList from "./ProjectsList/ProjectsList.js";
import AddNewProject from "./AddNewProject/AddNewProject.js";
import ProjectNotification from "./ProjectNotification/ProjectNotification.js";
import ProjectSpend from "./ProjectSpend/ProjectSpend.js";
import { useDebouncedLog } from "../../useDebouncedLog.js";
const Projects = () => {
  const [listActive, setListActive] = useState(true);
  const [AddCategory, setAddCategory] = useState(false);
  const [NewCategoryAddedPopup, setNewCategoryAddedPopup] = useState(false);
  const [openUpdateProjects, setOpenUpdateProjects] = useState(false);
  const [OpenNotification, setOpenNotification] = useState(false);
  const [Message, setMessage] = useState(false);

  var logProjectVisited;
  try {
    logProjectVisited = useDebouncedLog("admin_project_visited", 500);
  } catch (err) {
    console.log("error", err);
  }
  useEffect(() => {logProjectVisited()}, [logProjectVisited]);
  
  return (
    <>
      <div className={styles.ProjectContainer}>
        <div className={styles.ProjectsHeading}>
          <div className={styles.ProjectNavigate}>
            <div
              className={
                !listActive ? styles.NavigatebtnActive : styles.Navigatebtn
              }
              onClick={() => {
                setListActive(false);
              }}
            >
              Project Spends
            </div>
            <div className={styles.BorderLeft}></div>
            <div
              className={
                listActive ? styles.NavigatebtnActive : styles.Navigatebtn
              }
              onClick={() => {
                setListActive(true);
              }}
            >
              Project List
            </div>
          </div>
          <div
            className={styles.NewProjectBtn}
            onClick={() => {
              setAddCategory(true);
            }}
          >
            <img src={"/pluscircle.svg"} className={styles.AddIcon} />
            Add New Projects
          </div>
        </div>
        <div className={styles.SpendListContainer}>
          {listActive ? (
            <ProjectList
              openUpdate={() => {
                setOpenUpdateProjects(true);
                setAddCategory(true);
              }}
            />
          ) : (
            <ProjectSpend />
          )}
        </div>
      </div>
      {console.log("openUpdateProjects", openUpdateProjects)}
      {AddCategory && (
        <div className={styles.newUsersOverlay2}>
          <AddNewProject
            isVisible={AddCategory}
            setClose={() => {
              setOpenUpdateProjects(false);
              setAddCategory(false);
            }}
            Edit={openUpdateProjects}
            NewCategoryAdded={() => {
              openUpdateProjects
                ? setMessage("Project edited successfully ") //console.log("updated")
                : setMessage("Project added successfully"); //console.log("created");

              setOpenUpdateProjects(false);
              setNewCategoryAddedPopup(true);
              setOpenNotification(true);
            }}
          />
        </div>
      )}

      {OpenNotification && (
        <div className={styles.newUsersOverlay2Mid}>
          <ProjectNotification
            isVisible={OpenNotification}
            setClose={() => {
              setOpenNotification(false);
            }}
            message={Message}
          />
        </div>
      )}
    </>
  );
};
export default Projects;
